// Types
import { ProposalDAOInterface, ProposalTextsDAOInterface } from '../ProposalDAO';
import BaseTextDAO from './BaseTextDAO';
import * as ProposalNS from '../../Proposal';
import * as ProposalElementNS from '../../ProposalElements';

export default class TextDAO extends BaseTextDAO implements ProposalTextsDAOInterface {
  public static buildInstance(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement): ProposalDAOInterface {
    return new TextDAO(proposal, proposalElement);
  }

  localizedTextDAOOptions: ProposalNS.LocalizedTextDAOOptions | null = null;

  itemIndex?: number;

  /* eslint-disable-next-line class-methods-use-this */
  protected getColorKeys(): string[] {
    return [];
  }

  protected build(): void {
    // test for options
    const daoConfig: ProposalNS.TextConfig = this.proposalElement.DAO as ProposalNS.TextConfig;
    if (daoConfig.localizedTextDAOOptions !== undefined) {
      this.localizedTextDAOOptions = daoConfig.localizedTextDAOOptions;
    }

    const filter: ProposalNS.FilterItemsByIndexDAOOptions | undefined = daoConfig.filterItemsByIndexDAOOptions;
    if (filter !== undefined) {
      this.proposal.items.forEach((item, index) => {
        const localIndex: number =
          this.proposal.template.customParameters && this.proposal.template.customParameters.singleItemShift && this.proposal.items.length === 1
            ? index + 1
            : index;

        if (filter.itemIterator !== undefined && index === this.proposal.itemIterators.get(filter.itemIterator)) {
          this.itemIndex = index;
        }

        // absolute selection references must be relative to the singleItemShift, we use localIndex.
        if (filter.selection !== undefined && filter.selection.indexOf(localIndex) !== -1) {
          this.itemIndex = localIndex;
        }
      });
    }
  }

  getTexts(metadata?: ProposalNS.DAOGetTextsMetadata): Array<{ text: string; className?: string; tag?: string }> {
    const out: Array<{ text: string; className?: string; tag?: string }> = [];
    let { itemIndex } = this;

    if (itemIndex === undefined) {
      itemIndex = metadata ? metadata.itemIndex : undefined;
    }

    const textMetadata: ProposalNS.DAOGetTextsMetadata = {
      ...metadata,
      itemIndex,
    };

    if (this.localizedTextDAOOptions !== null) {
      this.localizedTextDAOOptions.texts.forEach(text => {
        const textStr: string = this.formatLocalizedString(text.text);
        const processedTextStr: string = this.processWildcards(textStr, textMetadata);

        out.push({ text: processedTextStr, className: text.className, tag: text.tag });
      });

      if (this.proposalElement.pageOverflowIndex !== 0 && this.localizedTextDAOOptions.pageOverflowSuffix !== undefined) {
        out.push({
          text: this.formatLocalizedString(this.localizedTextDAOOptions.pageOverflowSuffix.text),
          className: this.localizedTextDAOOptions.pageOverflowSuffix.className,
        });
      }
    }

    return out;
  }
}
